import { TimelineMax, Power3 } from 'gsap';

const WineDetailsIn = (element) => {
  const chars = [...element.querySelectorAll('.wine-details__title-char')];
  const text = element.querySelector('.wine-details__text');
  const image = element.querySelector('.wine-details__image');
  const details = [...element.querySelectorAll('.wine-details__detail')];

  const tl = new TimelineMax({ paused: true });
  tl.addLabel('start')
    .staggerTo(chars, 1, {
      y: 0,
      autoAlpha: 1,
      ease: Power3.easeOut,
    }, 0.02, 'start')
    .to(text, 1, {
      y: 0,
      autoAlpha: 1,
      ease: Power3.easeOut,
    }, 'start+=0.6')
    .to(image, 1, {
      autoAlpha: 1,
      ease: Power3.easeOut,
    }, 'start')
    .staggerTo(details, 1, {
      y: 0,
      autoAlpha: 1,
      ease: Power3.easeOut,
    }, 0.02, 'start+=0.6');
  return tl;
};

export default WineDetailsIn;
